export const updateUserAnnouncement = /* GraphQL */ `
  mutation UpdateUserAnnouncement($input: UpdateUserAnnouncementInput!) {
    updateUserAnnouncement(input: $input) {
      announcementId
      isRead
    }
  }
`;
